// test660
(660 && 0);
